<template lang="pug">
div
	kendo-datasource(ref="datasource1",
		:transport-read="transportRead",
		v-bind='datasource'
		:page-size='DSpageSize',
		:server-paging="DSserverPaging",
		:schema-data="DSschemaData",
		:schema-total="DSschemaTotal",
		:schema-parse="DSschemaParse"
		:filter="DSfilter",
		:server-filtering="DSserverFiltering"
		v-if="DSschema"
	)
	kendo-datasource(ref="datasource1",
		:transport-read="transportRead",
		v-bind='datasource'
		:page-size='DSpageSize',
		:server-paging="DSserverPaging",
		:filter="DSfilter",
		:server-filtering="DSserverFiltering"
		v-else
	)
	kendo-grid(:data-source-ref="'datasource1'", :height="GridHeight" :pageable='GridPageable', :pageable-always-visible="GridPageableAlwaysVisible" :pageable-page-sizes="GridPageablePageSizes")
		kendo-grid-column(v-for='(column, i) in columns',
			:key='i',
			v-bind='column')
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import '@progress/kendo-ui'
import '@progress/kendo-theme-default/dist/all.css'
import '@progress/kendo-ui/js/cultures/kendo.culture.pt-BR'
import '@progress/kendo-ui/js/messages/kendo.messages.pt-BR'

import { Grid, GridInstaller } from '@progress/kendo-grid-vue-wrapper'
import {
	DataSource,
	DataSourceInstaller
} from '@progress/kendo-datasource-vue-wrapper'

Vue.use(GridInstaller)
Vue.use(DataSourceInstaller)
// eslint-disable-next-line no-undef
kendo.culture('pt-BR')

export default {
	name: 'Grid',
	props: {
		url: {
			required: true
		},
		columns: {
			required: true
		},
		source: {
			required: false
		},
		GridHeight: {
			default: 500,
			required: false
		},
		GridPageable: {
			required: false
		},
		GridPageableAlwaysVisible: {
			default: false,
			required: false
		},
		GridPageablePageSizes: {
			value: [5, 10, 20, 100],
			required: false
		},
		DSpageSize: {
			required: false
		},
		DSserverPaging: {
			required: false
		},
		DSschema: {
			required: false,
			default: false
		},
		DSschemaData: {
			required: false
		},
		DSschemaTotal: {
			required: false
		},
		DSschemaParse: {
			required: false
		},
		DSfilter: {
			required: false
		},
		DSserverFiltering: {
			required: false
		},
	},
	components: {
		Grid,
		DataSource
	},
	computed: {
		datasource() {
			return this.source
		}
	},
	methods: {
		transportRead(options) {
			axios
				.get(this.url, {
					params: options.data,
					headers: {
						Authorization: 'Bearer ' + localStorage.getItem('token'),
						Accept: 'application/json'
					}
				})
				.then((response) => {
					options.success(response.data)
				})
				.catch((error) => {
					options.error(error)
				})
		}
	},
	mounted() {
		// this.$refs.datasource1.kendoDataSource.read()
	}
}
</script>

<style lang="stylus" scoped>
a.k-header-column-menu {
  z-index: 0 !important;
}
</style>
